var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoNotEnter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M80 224c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z",
  style: {
    opacity: 0.4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512M96 208h320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16",
  className: "do-not-enter_svg__fa-primary"
})));
export default SvgDoNotEnter;